import { render } from "./NotificationAction.vue?vue&type=template&id=359d7e82"
import script from "./NotificationAction.vue?vue&type=script&lang=js"
export * from "./NotificationAction.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__